export default __webpack_public_path__ + "static/media/hot-mop-1.259eea5e.jpg";